import type {IQueryBuilderConfig} from './IQueryBuilder';
import {QueryBuilder} from './QueryBuilder';
import {coreQueryBuilderConfig} from './queryBuilderConfig';

export {QueryBuilder, coreQueryBuilderConfig};
export type {IQueryBuilderConfig};

export default new QueryBuilder(coreQueryBuilderConfig);
